import {
  getPushNotificationAlertStatus,
  togglePushNotificationAlertStatus,
} from '@core/Utils/notifications/pushNotificationAlerts'
import { postFollowedAccountNotifications } from '@core/Areas/FollowMe/helpers/api'

export async function checkPushNotificationRegistration(
  accountId: string,
  isNotificationsEnabled: boolean,
  accountNumber: number
) {
  const registered = await getPushNotificationAlertStatus(accountNumber, 'followme')

  if (!registered) {
    await togglePushNotificationAlertStatus({
      accountNumber,
      isEnabled: true,
      alertType: 'followme',
      deepLink: '',
    })
  }
  postFollowedAccountNotifications(accountId, !isNotificationsEnabled)
}
